<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Impulsores" :content="meta.total" icon="users" />
      <sys-widget title="Comisiones" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import promotersService from '@/services/promoters'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'

export default {
  name: 'Promoters',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Impulsores',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'fullname' },
        { text: '% Comisión', value: 'comision' },
        { text: 'Monto por Pagar', value: 'comision_amount', filter: formatCurrency },
        { text: 'Acreedores', value: 'investors_count' },
        { text: 'Correo electrónico', value: 'email' }
      ],
      items: [],
      filtered_items: [],
      pending_comisions: 0,
      error_message: 'There\'s nothing to show :c',
      detail_route: 'promoter',
      create_route: 'promoter_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'name',
          name: 'Impulsor',
          hint: 'Impulsor',
          icon: 'user',
          type: 'text',
          value: '',
          size: 6,
          validator: (item, value) => item.name.toLowerCase().includes(value.toLowerCase()) || (item.corporate_name && item.corporate_name.toLowerCase().includes(value.toLowerCase()))
        },
        {
          id: 'email',
          name: 'Correo electrónico',
          hint: 'Correo electrónico',
          icon: 'mail-bulk',
          type: 'text',
          value: '',
          size: 6,
          validator: (item, value) => item.email.toLowerCase().includes(value.toLowerCase())
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      promotersService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promoters/Promoters.vue